<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <v-toolbar-title class="white--text">รายงานแผนการสอน</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12  md12 >
            <v-autocomplete
              :loading="loadingAcademicYearItems"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="params.academicYear"
              item-value="id"
              item-text="yearSemester"
              no-data-text="ไม่พบข้อมูล"
              outline
              hide-details
              return-object
              @change="params.activeCourse = null, sectionItems = []"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12  md12 >
            <v-autocomplete
              :loading="loadingSubjectItems"
              :items="sortedArray"
              label="วิชา"
              v-model="params.activeCourse"
              item-value="id"
              item-text="label"
              no-data-text="ไม่พบข้อมูล"
              outline
              hide-details
              return-object
              clearable
              :disabled="!params.academicYear"
              @change="params.activeCourse ? fecthSection(params.activeCourse.activeCourseId) : false"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12  md12 >
            <v-autocomplete
              :loading="loadingSectionItems"
              :items="sectionItems"
              label="กลุ่ม"
              v-model="params.section"
              item-value="id"
              item-text="name"
              no-data-text="ไม่พบข้อมูล"
              outline
              hide-details
              return-object
              clearable
              :disabled="!params.activeCourse"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-menu
              ref="menuFromDate"
              :close-on-content-click="false"
              v-model="menuFromDate"
              :nudge-right="40"
              :nudge-top="20"
              :return-value.sync="params.fromDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :disabled="!params.academicYear"
            >
              <v-text-field
                slot="activator"
                :value="date(params.fromDate)"
                label="ตั้งแต่วันที่"
                prepend-icon="event"
                readonly
                outline
                :disabled="!params.academicYear"
              ></v-text-field>
              <v-date-picker v-model="params.fromDate" @input="$refs.menuFromDate.save(params.fromDate)" no-title locale="th-Th"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-menu
              ref="menuToDate"
              :close-on-content-click="false"
              v-model="menuToDate"
              :nudge-right="40"
              :nudge-top="20"
              :return-value.sync="params.toDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :disabled="!params.academicYear"
            >
              <v-text-field
                slot="activator"
                :value="date(params.toDate)"
                label="ถึงวันที่"
                prepend-icon="event"
                readonly
                outline
                :disabled="!params.academicYear"
              ></v-text-field>
              <v-date-picker v-model="params.toDate" @input="$refs.menuToDate.save(params.toDate)" no-title locale="th-Th"></v-date-picker>
            </v-menu>
            
          </v-flex>
          <v-flex xs12 md3>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn 
                color="blue-grey" 
                fab 
                small  
                dark
                v-on="on"
                @click="params.fromDate = null, params.toDate = null">
                  <v-icon>clear</v-icon>
                </v-btn>
              </template>
              <span>ล้างค่าวันที่</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          target="_new" 
          :href="printoutUrl"
          v-if="params.academicYear"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      menuFromDate: false,
      menuToDate: false,
      disabled: false,
      loading: false,
      loadingAcademicYearItems: false,
      loadingSubjectItems: false,
      loadingSectionItems: false,
      academicYearItems: [],
      subjectItems: [],
      sectionItems: [],
      params: {
        academicYear: null,
        activeCourse: null,
        section: null,
        fromDate: null,
        toDate: null
      },
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง',
        required2: (value) => value == "NORMAL" || value == "INTER" || value == "ARCH" || "ไม่สามารถเป็นค่าว่าง",
        required3: (value)  => !!value.id || 'ไม่สามารถเป็นค่าว่าง'
      }
    }
  },
  computed: {
    ...mapGetters ({
      token: 'token'
    }),
    printoutUrl () {
      let academicYear = this.params.academicYear ? this.params.academicYear.id : ''
      let activeCourse = this.params.activeCourse ? this.params.activeCourse.id : ''
      let section = this.params.section ? this.params.section.id : ''
      let fromDate = this.params.fromDate ? this.params.fromDate : ''
      let toDate = this.params.toDate ? this.params.toDate : ''
      return `${config.serverURI}/reports/printout/coursePlan?academicYear=${academicYear}&activeCourse=${activeCourse}&section=${section}&fromDate=${fromDate}&toDate=${toDate}&access_token=${this.token}`
    },
    sortedArray: function() {
      function compare(a, b) {
        if (a.code < b.code)
          return -1;
        if (a.code > b.code)
          return 1;
        return 0;
      }

      return this.subjectItems.sort(compare);
    }
  },
  mounted () {
    this.fetchAcademicYears ()
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    fetchAcademicYears () {
      this.loadingAcademicYearItems = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loadingAcademicYearItems = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYearItems = false
        })
    },
    fetchActiveCourseItemsByAcademicYear (academicYear) {
      this.loadingSubjectItems = true
      this.$store.dispatch("activeCourse/loadItemsByAcademicYear", academicYear)
        .then((response) => {
          this.subjectItems = []
          for (const item of response.data) {
            let label = item.subject.code + " - " + item.subject.nameTh + " - " + this.$t(`courseType.${item.courseType}`)
            this.subjectItems.push({ id: item.id, code: item.subject.code, label: label, activeCourseId: item.id })
          }
          this.loadingSubjectItems = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingSubjectItems = false
        })
    },
    fecthSection (activeCourseId) {
      // console.log('fecthSection', activeCourseId)
      this.loadingSectionItems = true
        this.$store.dispatch('section/fetchItemByActiveCourse', activeCourseId)
        .then((response) => {
          this.loadingSectionItems = false
          this.sectionItems = response.data
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingSectionItems = false
        })
    }
  },
  watch: {
    'params': {
      handler (val) {
        if(val.academicYear && val.academicYear.id>0) this.fetchActiveCourseItemsByAcademicYear(val.academicYear.id)
        if(!val.academicYear || val.academicYear.id===0) {
          this.subjectItems = []
          this.sectionItems = []
          this.params.section = null
        }
        if( val.fromDate && val.toDate ) {
          let fd = moment(val.fromDate)
          let td = moment(val.toDate)
          if(td.diff(fd) < 0) this.params.fromDate = this.params.toDate
          this.active = true
        }
        if( val.activeCourse == null ) {
          this.sectionItems = []
          this.params.section = ''
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/coursePlan/index.vue